var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpInfo16 = function SvgHelpInfo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 6.563a2.4 2.4 0 0 1 3.731-1.997l.106.07A2.163 2.163 0 0 1 8.6 8.57v.63a.6.6 0 0 1-1.2 0V8.164c0-.422.342-.764.764-.764h.073a.963.963 0 0 0 .534-1.765l-.105-.07a1.2 1.2 0 0 0-1.866.998V6.8a.6.6 0 0 1-1.2 0v-.237ZM8.6 11a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM3.2 8a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0Z",
    fill: "currentColor"
  })));
};
export default SvgHelpInfo16;